import { render, staticRenderFns } from "./SCross.vue?vue&type=template&id=095cde6b&"
import script from "./SCross.vue?vue&type=script&lang=ts&"
export * from "./SCross.vue?vue&type=script&lang=ts&"
import style0 from "./SCross.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports